import Err from 'models/err';
import ErrorDtoConverter from 'scripts/application/dto_converters/err_converter';
import ShowToast from 'actions/toast_deprecated/show_toast';
import SnippetConverter from 'scripts/application/dto_converters/snippet_converter';
import TeamAssistPanel from 'models/team_assist_panel';
import { ToastType } from 'models/toast_deprecated';

export default class FetchTeamAssistAnswer {
  constructor(context) {
    this.context = context;
  }

  run({ answerId }) {
    const store = this.context.stores.teamAssistPanel;
    store.setLoading();

    return this.context.gateways.snippet
      .fetch({ snippetId: answerId })
      .then(snippetDto => {
        const answer = SnippetConverter.fromDto(snippetDto);
        store.set(TeamAssistPanel.create({ answer }));
      })
      .catch(errorDto => {
        const error = ErrorDtoConverter.fromDto(errorDto);
        if (error.code === Err.Code.NOT_EXIST) {
          this.context.executeAction(ShowToast, {
            type: ToastType.WARN,
            message: 'Hmmm, it looks like that answer was deleted',
          });
          return;
        }
        this.context.executeAction(ShowToast, {
          type: ToastType.ERROR,
          message: 'Could not load the answer',
        });
      })
      .finally(() => {
        store.resetLoading();
      });
  }
}
